import { render, staticRenderFns } from "./upper_abdomen.vue?vue&type=template&id=7357a7ee"
import script from "./upper_abdomen.vue?vue&type=script&lang=js"
export * from "./upper_abdomen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports